import React, { Component } from "react";
import { get as _get } from "lodash";

export default class CrewSheetDrivingDirections extends Component {
  getMilesFromMeters = (meters) => {
    return Math.round((meters / 1609.344) * 100) / 100;
  };

  //durantion comes in seconds
  makeDurationReadable = (duration) => {
    if (!duration) return "";

    const total_minutes = Math.round(duration / 60);
    const hours = Math.floor(total_minutes / 60);
    const minutes = total_minutes % 60;
    let result = "";

    if (hours) {
      result += hours + "h ";
    }

    result += minutes + "min";
    return result;
  };

  buildLegLabel(crew, leg, index) {
    const legs = _get(crew, "directions.legs", []);
    const sites = _get(crew, "canvassers[0].sites", []);
    const canvassers = _get(crew, "canvassers", []);

    if (crew.route_to_all_sites) {
      const isReturnLeg = index === legs.length - 1;
      if (isReturnLeg) {
        return { title: "Return to Office", destination: "Office" };
      }
      const site = sites[index] || {};
      return {
        title: site.name || `Site ${index + 1}`,
        destination: site.addressline1
          ? `${site.addressline1}, ${site.city || ""}`
          : "",
      };
    }

    const canvasser = canvassers[index] || {};
    const name = [canvasser.firstname, canvasser.lastname]
      .filter(Boolean)
      .join(" ");
    const dest =
      _get(canvasser, "dropoff.name", "") ||
      _get(canvasser, "dropoff.address", "") ||
      _get(canvasser, "dropoff.addressline1", "") ||
      _get(canvasser, "dropoff.waypoint.name", "");
    const coordFallback =
      !dest && canvasser.dropoff
        ? `${_get(canvasser, "dropoff.latitude", "")}, ${_get(
            canvasser,
            "dropoff.longitude",
            ""
          )}`
        : "";

    return {
      title: name || `Stop ${index + 1}`,
      destination: dest || coordFallback,
    };
  }

  buildListDirections() {
    let { crew } = this.props;
    let legElems = [];

    _get(crew, "directions.legs", []).forEach((leg, index) => {
      const { title, destination } = this.buildLegLabel(crew, leg, index);
      let stepElems = [];

      if (leg.steps) {
        leg.steps.forEach((step, i) => {
          stepElems.push(
            <div key={`step-${index}-${i}`} className="step-item">
              <div className="step-instruction">
                {_get(step, "maneuver.instruction", "")}
              </div>
              <div className="step-meta">
                {this.makeDurationReadable(step.duration)} &middot;{" "}
                {this.getMilesFromMeters(step.distance)} mi &middot; step{" "}
                {i + 1}/{leg.steps.length}
              </div>
            </div>
          );
        });
      }

      legElems.push(
        <div key={`leg-${index}`} className="column-list">
          <div className="leg-header">
            <span className="leg-number">{index + 1}</span>
            <div className="leg-label">
              <h5>{title}</h5>
              {destination && (
                <div className="leg-destination">{destination}</div>
              )}
            </div>
          </div>
          <div className="leg-summary">
            {this.makeDurationReadable(leg.duration)} &middot;{" "}
            {this.getMilesFromMeters(leg.distance)} miles
          </div>
          <div className="leg-steps">{stepElems}</div>
        </div>
      );
    });
    return legElems;
  }

  render() {
    return (
      <div className="directions-section">
        <div className="directions-section-title">Driving Directions</div>
        <div className="wrap-list">{this.buildListDirections()}</div>
      </div>
    );
  }
}
